import React, { useEffect, useState } from "react";
import api from "../../../Services/api";
import { useHistory } from "react-router-dom";
import { BsArrowLeft, BsArrowRight, BsEyeFill } from "react-icons/bs";
import ReactLoading from "react-loading";
import SidebarMenu from "../../../Components/SidebarMenu";
import {
  Page,
  ErrorMsg,
  ErrorBtn,
} from "./styles";
import { PageTitle } from "../CadastrarMedico/styles";
import StatusDisplay from "../../../Components/Status";
import PageContainer from "../../../Components/PageContainer";
import { Background, RightDiv } from "../Perfil/styles";
import DataTable from "react-data-table-component";
import ExportCSVButton from "../../../Components/ExportCSVButton";
import CreatableSelect from "react-select/creatable";

export default function Procedimentos() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [errorRepositories, setErrorRepositories] = useState(null);
  const [appointmentsData, setAppointmentsData] = useState([]);
  const [infoPagina, setInfoPagina] = useState(
    {
      has_next: false,
      has_previous: false,
      per_page: 20,
      page: 1,
      total: 0,
    }
  );
  const [quantidadeExibidaNaTabela, setQuantidadeExibidaNaTabela] = useState({ label: "20", value: 20 });

  const colunasTabela = [
    {
      name: 'Paciente/Dependente',
      selector: row => !row.afiliado ? (row.paciente.usuario.NO_primeiro_nome ?? "" + " " + row.paciente.usuario.NO_ultimo_nome ?? "") : (row.afiliado.usuario.NO_primeiro_nome ?? "" + " " + row.afiliado.usuario.NO_ultimo_nome ?? ""),
    },
    {
      name: 'Procedimento',
      selector: row => row.DS_transferencia || '-',
    },
    {
      name: 'Data',
      selector: row => new Date(row.DT_criacao).toLocaleDateString("pt-BR"),
    },
    {
      name: 'Valor',
      selector: row => row.QT_credito,
    },
    {
      name: 'Token',
      selector: row => row.CD_token,
    },
    {
      name: 'Status',
      selector: (row) => (
        <StatusDisplay status={row.ST_transferencia}>
          {row.ST_transferencia}
        </StatusDisplay>
      ),
    },
    {
      name: '',
      maxWidth: '40px',
      selector: row =>
        <BsEyeFill
          className="cursor-pointer"
          onClick={() => {
            history.push(`/procedimentos/${row.id_transferencia}`);
          }} size={20} color="#7A99E3"
        />,
    },
  ];

  const dropdownCustomStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "10vw",
      minHeight: "30px",
      borderRadius: "10px",
      backgroundColor: "#fafafa",
      fontSize: "18px",
      color: "black",
      border: "1px solid #d5d5d5",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "black", // Cor do texto das opções
    }),
  };

  const opcoesQuantidadeExibidos = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "15", value: 15 },
    { label: "20", value: 20 }
  ];

  const fetchAppointmentsData = async () => {
    setLoading(true);
    setErrorRepositories(null);

    try {
      const response = await api.get(`/transferencia/minhas-transferencias?page=${infoPagina.page}&per_page=${infoPagina.per_page}&procedimento=true`);

      setAppointmentsData(response.data.transferencias);
      console.log("response.data", response.data);
      setInfoPagina(
        {
          ...infoPagina,
          has_next: response.data.has_next,
          has_previous: response.data.has_previous,
          total: response.data.total,
        }
      );
    } catch (error) {
      setErrorRepositories("Ocorreu um erro ao carregar a página");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const proximaPagina = async (proxima) => {
    console.log("foi de next");
    if (proxima) {
      setInfoPagina({ ...infoPagina, page: infoPagina.page + 1 });
    }
    else {
      setInfoPagina({ ...infoPagina, page: infoPagina.page - 1 });
    }
  };

  const mudarQuantidadeExibida = async (quantidade) => {
    setQuantidadeExibidaNaTabela(quantidade);
    setInfoPagina({ ...infoPagina, per_page: quantidade.value });
  }

  useEffect(() => {
    fetchAppointmentsData();
  }, [infoPagina.page, infoPagina.per_page]);

  function refresh() {
    window.location.reload();
  }

  if (errorRepositories) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Histórico de Procedimentos</PageTitle>
          <ErrorMsg>{errorRepositories}</ErrorMsg>
          <ErrorBtn onClick={(event) => refresh(event)}>
            Tentar novamente
          </ErrorBtn>
        </PageContainer>
      </Page>
    );
  }

  if (loading) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Histórico de Procedimentos</PageTitle>
          <ReactLoading
            type="spin"
            color="#B2EBF2"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        {/* <PageTitle>Histórico de Consultas</PageTitle>
        <Tabela rows={appointmentsData} columns={columns} /> */}
        <Background>
          <RightDiv>
            <PageTitle>Histórico de Procedimentos</PageTitle>
            <div className="flex flex-col w-full space-y-2">
              <div className="flex flex-row w-full justify-between items-center">
                <p className="text-white font-bold pr-2">Exibir:</p>
                <CreatableSelect
                  options={opcoesQuantidadeExibidos}
                  required
                  value={quantidadeExibidaNaTabela}
                  onChange={(e) => {
                    e.value > 20 ? mudarQuantidadeExibida(opcoesQuantidadeExibidos.at(-1)) : mudarQuantidadeExibida(e);
                  }}
                  styles={dropdownCustomStyles}
                  placeholder={"Selecione a quantidade que será exibida na tabela"}
                />
                <ExportCSVButton exportData={appointmentsData} />
              </div>
              <div className="w-full max-h-96 overflow-x-auto overflow-y-visible">
                <DataTable
                  columns={colunasTabela}
                  data={appointmentsData}
                  responsive
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: "#EFCA04",
                        fontSize: "16px",
                      },
                    },
                  }}
                />
              </div>

              <div className="flex flex-row w-full justify-between items-center">
                <BsArrowLeft
                  className={infoPagina.has_previous ? "cursor-pointer" : "cursor-not-allowed"}
                  onClick={() => infoPagina.has_previous && proximaPagina(false)}
                  size={50}
                  color={infoPagina.has_previous ? "#EFCA04" : "#ebe0a7"} />
                <p className=" text-[#EFCA04]">
                  {infoPagina.page + "/" + Math.ceil(infoPagina.total / infoPagina.per_page)}
                </p>
                <BsArrowRight
                  className={infoPagina.has_next ? "cursor-pointer" : "cursor-not-allowed"}
                  onClick={() => infoPagina.has_next && proximaPagina(true)}
                  size={50}
                  color={infoPagina.has_next ? "#EFCA04" : "#ebe0a7"} />
              </div>
            </div>
          </RightDiv>
        </Background>
      </PageContainer>
    </Page>
  );
}
